import { render, staticRenderFns } from "./ProjectDasboard.vue?vue&type=template&id=acbaea68&lang=pug&"
import script from "./ProjectDasboard.vue?vue&type=script&lang=js&"
export * from "./ProjectDasboard.vue?vue&type=script&lang=js&"
import style0 from "./ProjectDasboard.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports